import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import CaregiverState, { ICaregiver, CaregiverList } from './states'
import _ from 'lodash'
import axios from 'axios'

const completePathFn = process.env.VUE_APP_BASEURL
const mutations: MutationTree<CaregiverState> = {
  [mutationType.GET_LISTS](
    state: CaregiverState,
    data: CaregiverList,
  ): void {
    state.list = data
  },
  [mutationType.GET_BY_ID](
    state: CaregiverState,
    data: ICaregiver,
  ): void {
    state.byId = data
  },
}

export default mutations
